import React, { Component } from "react";
import { themeClass, headerSuffix } from "~/store/actions";
import { connect } from "react-redux";
import { pageMapStateToProps } from "~/store/mappers";
import axios from "axios";
import Volby2026OskPage from "~/components/pages/Volby2026OskPage";
import { BASE_URL, isAllowedIp } from "~/utility/volby2026";

const POLL_INTERVAL = 60000;

class PageVolby2026Osk extends Component<any, any> {
  pollTimer: ReturnType<typeof setInterval> | null = null;

  constructor(props) {
    super(props);
    this.state = {
      legend: {},
      results: {},
      allowed: false,
    };
  }

  update(props) {
    const { dispatch } = props;
    dispatch(headerSuffix("Voľby 2026", "/volby-2026"));
    dispatch(themeClass("theme_prave-teraz"));
  }

  fetchResults = () => {
    axios
      .get(`${BASE_URL}/osk_results.json`)
      .then((res) => this.setState({ results: res.data }))
      .catch(() => {});
  };

  UNSAFE_componentWillMount() {
    this.update(this.props);

    axios
      .get("https://api.ipify.org/?format=json")
      .then((res) => {
        if (isAllowedIp(res.data?.ip)) {
          this.setState({ allowed: true });
        }
      })
      .catch(() => {});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.update(nextProps);
  }

  componentDidMount() {
    this.update(this.props);

    axios
      .get(`${BASE_URL}/osk_legend.json`)
      .then((res) => this.setState({ legend: res.data }))
      .catch(() => {});

    this.fetchResults();
    this.pollTimer = setInterval(this.fetchResults, POLL_INTERVAL);
  }

  componentWillUnmount() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  }

  render() {
    const { legend, results, allowed } = this.state;
    if (!allowed) return <div></div>;
    return <Volby2026OskPage legend={legend} results={results} />;
  }
}

export default connect(pageMapStateToProps)(PageVolby2026Osk);
